/* eslint-disable */
import React from "react";
import { Row, Col, Container } from "reactstrap";
// 多语言
import { useTranslation } from "react-i18next";

const MainContent = () => {

  const { t } = useTranslation();
  return (
    <div>
      <div className="spacer" data-aos="fade-up-left">
        <Container>
          <Row className="justify-content-center">
            {/* <h1 className="title font-bold">miPoolについて</h1> */}
            <Col md="12" className="text-left">
              <p>
                {t(
                  "As a professional team of cryptocurrency mining, miPool has established in 2016 and has been mining major cryptocurrencies and developing blockchain infrastructure technology mainly in Asia. We have proven our achievements and technical knowladges in Bitcoin and ETH POW mining, POS staking such as EOS DPoS, Polkadot NPoS, and Filecoin (WindowPoS) mining. "
                )}
              </p>
              <p>
                {t(
                  "In August 2020, our team launched a Filecoin cloud mining service "
                )}
                （
                <a href="https://jp.cointelegraph.com/press-releases/filecoin-filmipool">
                  https://jp.cointelegraph.com/press-releases/filecoin-filmipool
                </a>
                ）
                {t(
                  "in Japan. The service is currently offering promising results daily. For your reference, here is our 1st Filecoin miner production status: "
                )}
                <a href="https://filfox.info/en/address/f024015">
                  https://filfox.info/en/address/f024015
                </a>
              </p>
              <p>
                {t(
                  "In May 2021, a Chia cloud farming service started. Based on the PoC consensus, as the same as Filecoin mining, Chia is aiming to be a Green Bitcoin, and its farming is expected to become one of the cryptocurrencies with very high potential from all over the world."
                )}
              </p>
              <p>
                {t(
                  "We are gradually launching validator nodes for Solana, MINA, CELR, and MATIC staking, and will introduce their staking services. Please stay tuned."
                )}
              </p>
              <p>
                {t(
                  "Our various services cover the core operations of cryptocurrency blockchains. miPool has carefully selected and mined blockchains that have potentials. Join us today to acquire major tokens as rewards that you could mine, and it could value a lot in the future.Would you be smiling with us in the future world of cryptocurrency blockchains."
                )}
              </p>
              <p>
                {t("Team miPool")}
                <br />
                {t("2021")}
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default MainContent;
